export const SHOW_SNACKBAR = 'showSnackbar';
export const SHOW_LOADER = 'showLoader';
export const REGISTER_ADMIN = 'registerAdmin';
export const FETCH_DISPENSARIES = 'fetchDispensaries';
export const DISPENSARIES_ADDED = 'dispensariesAdded';
export const ASSET_CREATED = 'assetCreated';
export const CREATE_PRODUCT = 'createProduct';
export const CLOSE_PRODUCT_SHEETS = 'closeProductSheets';
export const CREATE_COA_DIALOG = 'CREATE_COA';
